<template src="./Settings.html"></template>

<script>

export default {
  name: 'settings',
  props: ['mode'],
  data () {
    return {
      show: 0,
      sort: 'revenues',
      showEG: 0,
      showUE: 0,
      modus: 'top',
      period: ''
    }
  },
  watch: {
    sort: function() {
      this.$parent.sort = this.sort
      this.$parent.fetchData()
    },
    showEG: function() {
      this.$parent.showEG = this.showEG
      this.$parent.fetchData()
    },
    showUE: function() {
      this.$parent.showUE = this.showUE
      this.$parent.fetchData()
    },
    modus: function() {
      this.$parent.modus = this.modus
      this.$parent.fetchData()
    },
    period: function() {
      this.$parent.period = this.period
      this.$parent.fetchData()
    }
  },
  methods: {
    resetSearch() {
      this.$parent.searchword = ''
      this.$parent.reduceList('')
    },
    closeSettings() {
      this.show = 0
    },
    getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Settings.vue?2aadf7a9